<template>


  <div v-if="(StoreShowPrePanierListe.length > 0)" class="div-pre-panier">
  
    <van-row>
      <van-col class="align-left m-t2 col-titre-configuration" span="16" >  
  
        <span class="hide-mobile">  <h4 class="m-t2 d-inline-block m-r2 titre-config">{{ $t('Configurations') }}</h4> </span>
  
     <span class="all-btn-liste">
  
      <span class="inline_flex m-r2"> 
      <ajoutRefPrk popOverPlacement="top" />  
    </span>
  
     <span v-if="actifAjoutNumSession" class="inline_flex m-r2"> 
      <ajoutNumSession popOverPlacement="top" />  
    </span>
  
     <span v-if="actifDevisBtn" class="inline_flex">  
      <ajoutRefDevis popOverPlacement="top" />  
    </span>
  
    
    <span v-if="storeSessionId" class="inline_flex popoverSession"> 
  
  <van-popover placement="top" v-model:show="showPopoverBtnCopy" :actions="actions" >
    
  <template #reference>
   
  <van-button  @click="showNumSession = true" style="width: 8.5rem;" @mouseover="showPopoverBtnCopy = true" plain @mouseleave="showPopoverBtnCopy = false"  class="btn-add-prk" size="small" type="default">
  <span class="m-r1">#</span>{{ $t('N° de session') }} 
  </van-button>
  </template>
  </van-popover>
  
  <van-popup closeable v-model:show="showNumSession" class=" all_border_radius" :style="{ padding: '50px'}"><b>{{ storeSessionId }}</b></van-popup>
  
  </span>
  
     </span>
      
    </van-col>
  
  
      <van-col class="align-right m-t2 col-demande-devis" span="8" > 
        <div v-if="StoreEnvWeb == 'Formulaire'">
          <van-popup closeable v-model:show="showNoQte" class=" all_border_radius" :style="{ padding: '50px'}"><b>{{ storeSessionId }}</b></van-popup>
  
  <buttonFormulaireShop   v-if="StoreEnvWeb == 'Formulaire'"   />
  
  
      </div> 
      <div v-if="StoreEnvWeb == 'CustomerCare GIGAMEDIA'">
        <van-sticky :offset-top="10">
          <van-button :disabled=true loading-type="spinner" v-if="ficheTechniqueLoading.some(status => status !== false)" loading :loading-text="$t('Demander mon devis')"  type="primary" ><span class="text-btn-devis"></span></van-button>
        <van-button v-if="devisGenEncours" :loading=false icon="cart-o" type="primary" ><Spinner /></van-button>
        <van-button 
        v-if="!devisGenEncours && !ficheTechniqueLoading.some(status => status !== false)" 
        :disabled="ficheTechniqueLoading.some(status => status !== false) || $store.state.storePrePanier.StoreShowPrePanierListe.toString() == $store.state.storePrePanier.StorePrePanierAddDevis.toString()" 
        :loading=false 
        :icon="logoBtn()"
        @click="demanderMonDevis" 
        type="primary" >
          {{ $t('Demander mon devis') }} 
        </van-button>
        <!-- <ajoutClientEmailDestination v-if="!devisGenEncours" /> -->
      </van-sticky>
      </div>
      <div v-else-if="StoreEnvWeb == 'Site Gigamedia'">
        <van-sticky :offset-top="10">
          
        <van-button :disabled=true loading-type="spinner" v-if="ficheTechniqueLoading.some(status => status !== false)" loading :loading-text="$t('Demander mon devis')"  type="primary" ><span class="text-btn-devis"></span></van-button>
        <van-button v-if="devisGenEncours" :loading=false icon="cart-o" type="primary" ><Spinner /></van-button>
        <van-button v-if="!devisGenEncours && !ficheTechniqueLoading.some(status => status !== false)" :disabled="ficheTechniqueLoading.some(status => status !== false) || $store.state.storePrePanier.StoreShowPrePanierListe.toString() == $store.state.storePrePanier.StorePrePanierAddDevis.toString()" :loading=false :icon="logoBtn()" @click="demanderMonDevis" type="primary" >{{ $t('Demander mon devis') }} </van-button>
        <!-- <ajoutClientEmailDestination v-if="!devisGenEncours" /> -->
      </van-sticky>
      </div>
      <div v-else-if="StoreEnvWeb == 'Webshop'" >
        <van-popup closeable v-model:show="showNoQte" class=" all_border_radius" :style="{ padding: '50px'}"><b>{{ storeSessionId }}</b></van-popup>
  
        <buttonMergeFicheTech   v-if="StoreEnvWeb == 'Webshop'"   />
        
       <!-- <van-button  :loading=false icon="cart-o" @click="addCart" type="primary" >{{ $t('Ajouter au panier Rexel') }} </van-button> -->
      </div>
    </van-col>
    </van-row>
  
  <div v-bind:class="{ pre_panier_liste_webshop : envWebName == 'Webshop' , pre_panier_liste_customer : envWebName == 'Formulaire' , pre_panier_liste_customer : envWebName == 'CustomerCare GIGAMEDIA' , pre_panier_liste_customer : envWebName == 'CustomerCare GIGAMEDIA' , pre_panier_liste_gigamedia : envWebName == 'Site Gigamedia' }" >
  
  
    
    <van-list >
  
      <van-cell class="cell_pre_liste_title">
       
  
  
      <van-row  class="align-left" gutter="1">
  
        <van-col  span="4"><b>{{ $t('Référence GIGAMEDIA') }}</b> </van-col>
        <van-col class="align-center" :span="(StoreEnvWeb == 'CustomerCare GIGAMEDIA') ? 13 : 15"><b>{{ $t('Description produit') }}</b> </van-col>
        <van-col  v-if="StoreEnvWeb == 'Webshop'"  span="3"><b>{{ $t('Référence REXEL') }}</b> </van-col>
        <van-col v-if="StoreEnvWeb == 'CustomerCare GIGAMEDIA'" span="2">
          <b>{{ $t('PFAS') }}</b>
        </van-col>
        <van-col></van-col>
      </van-row>
    </van-cell>
  
  
    <!-----  Refference crées par le configurateur  ---->
    
  <van-cell  v-for="item in StoreShowPrePanierListe"  :key="item.id" >
  
  <van-row  class="align-left row_pre_panier" gutter="1">
  
    <van-col span="4" class="color_ggm col-reference"><b>{{ item.ref_prk}}</b> </van-col>
  
    <van-col span="6" class="col-description">
      {{  item.nombre_fibre + ' FO ' +  item.type_fibre  + ' struct. ' + strLcFirst(item.type_structure)  }}  <span v-if="item.euroclass != 'Non applicable'"> {{  item.euroclass }} </span>
      
     </van-col>
  
    <van-col class="col-coa" :span="(StoreEnvWeb == 'CustomerCare GIGAMEDIA') ? 2 : 3 ">{{ item.connecteur_a+' / Ø '  + item.connecteur_a_diametre   }} </van-col>
  <van-col class="col-cob" :span="(StoreEnvWeb == 'CustomerCare GIGAMEDIA') ? 2 : 3  ">{{  item.connecteur_b+' / Ø '  + item.connecteur_a_diametre  }} </van-col>
  
  
  <van-col span="3" class="col-longueur">{{ item.longueur }}m
  
  <span v-if="item.longueur < 60"> / {{ $t('Couronne') }}</span>
  <span v-if="item.longueur >= 60 "> / {{ $t('Touret') }}</span>
  
  <span  v-for="itemStock in this.resultQteDispo" v-bind:key="itemStock.length">
    <span v-if="itemStock.id_ligne == item.id_perso && item.refGerree == false" >
  
  
      <van-popover :overlay="true"  placement="top" v-model:show="showPopoverQteCable[item.id_perso]"  @open="onSelectQteDispo(item.id_perso)" >
  
        <h4 class="align-center  title_pop_stock">{{ $t('Stock de câble') }}</h4>
  
        <div class="m-l-r-2">
          <van-image
              class=" m-t7px"
            width="1.2rem"
            fit="cover"
            position="left"
            src="https://admin-fibre.gigamedia.net/images/cable_stock/stock-bas.png"
            :show-loading = false
            />
            <span class="m-l-6" > {{ $t('Insuffisant') }}  </span>
        </div>
      
            <van-divider />
  
            <div class="m-l-r-2" >
              <van-image
          
            width="1.2rem"
            fit="cover"
            position="left"
            src="https://admin-fibre.gigamedia.net/images/cable_stock/stock-moyen.png"
            :show-loading = false
            />
            <span class="m-l-6 "  >{{ $t('Moyen') }}   </span> 
            </div>
         
            <van-divider />
  
  <div class="m-b7px m-l-r-2">
    <van-image
            
            width="1.2rem"
            fit="cover"
            position="left"
            src="https://admin-fibre.gigamedia.net/images/cable_stock/stock-haut.png"
            :show-loading = false
            />
            <span class="m-l-6"  > {{ $t('Suffisant') }}  </span> 
  
  </div>
      
        
     
  
  
  
  
    <template #reference>
     
  
        
         <van-image
              class="m-l-6 curseur_pointeur"
              v-if="itemStock.erreur"
            width="1rem"
            fit="cover"
            position="left"
            v-bind:src="'https://admin-fibre.gigamedia.net/images/cable_stock/' + itemStock.erreur + '.png'"
            :show-loading = false
            />
      
    </template>
  </van-popover>
     
      </span>  
  
  
  </span>
  
  
  </van-col>
  
  <van-col v-if="StoreEnvWeb == 'Webshop'" span="3" class="color_ggm col-ref-rexel">
    <span v-if="!item.pa_palier && item.etat"><Spinner/></span>
    <span v-if="item.pa_palier"> <b>{{ item.pa_palier.replace(' ','') }}</b> </span>
   
    <van-icon @click="clickShowPopoverErreur" v-if="item.etat == false || item.pa_ref_palier == false"  class="icon_error popover_erreur" name="question" />
  
    <span v-if="storeSessionId" class="popoverSession"> 
  
    <van-popup closeable v-model:show="showPopoverErreur" class="all_border_radius" :style="{ padding: '26px' }">
      {{ $t('erreur reference1') }} <br>
      {{ $t('erreur reference2') }} 
      <b>{{  storeSessionId  }}</b>
    </van-popup>
  </span>
  
  </van-col>
  <van-col v-if="StoreEnvWeb == 'CustomerCare GIGAMEDIA'" span="2"> 
    <span v-if="!item.pa_prix_net_palier && item.etat"><Spinner/></span>
    <span v-if="item.pa_prix_net_palier"> 
      <b>{{ this.$CryptoJS.AES.decrypt(item.pa_prix_net_palier, SaltEncode).toString(this.$CryptoJS.enc.Utf8)}}€</b> 
    </span>
  
  </van-col>
  
  <van-col v-if="StoreEnvWeb == 'Site Gigamedia'" span="3"> 
   
  </van-col>
  <van-col v-if="StoreEnvWeb == 'CustomerCare GIGAMEDIA'" span="3"> 
   
  </van-col>
  
  <van-col class="col-btn-fichetech"> 
  
  <buttonCreateFicheTech :item="item" v-if="item.pa_ref_palier" />
  
  
  
  <van-button @click="DeleteLignePrePanier(item.id_perso)" class="m-r1" size="small"   icon="cross" type="danger" />
  </van-col>
  
  
  </van-row>
  
  </van-cell>
  
  </van-list>
  
  
  </div>
  
     
      <van-row>
  
  </van-row>
  
      <van-grid direction="horizontal" :column-num="3">
      
  </van-grid>
  
  <div></div>
  
  
    </div>
  
  
  </template>
  
  <script>
  import { showNotify } from 'vant';
  import Spinner from '../../loader/LoaderSimple.vue' ;
  import buttonCreateFicheTech from './buttonCreateFicheTech.vue' ;
  import buttonMergeFicheTech from './buttonMergeFicheTech.vue' ;
  import buttonFormulaireShop from './buttonFormulaireShop.vue' ;
  import ajoutRefPrk from './ajoutRefPrk.vue' ;
  import ajoutRefDevis from './ajoutRefDevis.vue' ;
  import ajoutNumSession from './ajoutNumSession.vue';
  //import ajoutClientEmailDestination from './ajoutClientEmailDestination.vue' ;
  
  export default {
    components: {
      Spinner,
      buttonCreateFicheTech,
      buttonMergeFicheTech,
      buttonFormulaireShop,
     ajoutRefPrk ,
     ajoutRefDevis ,
     ajoutNumSession ,
     //ajoutClientEmailDestination
    },
    data() {
      return {
         actions : [
        { text:  this.$t('Sauvegarder session') },
      ],
      //pophover qte cable dispo
      showPopoverQteCable:[],
      actions2 : [
        { text: 'Option 1' },
        { text: 'Option 2' },
        { text: 'Option 3' },
      ],
  //!TODO faire disparaitre popover click hors popover
        showPopover: false,
        showPopover2: false,
        showPopoverErreur: false,
        showDoc: false,
        devisGenEncours: false,
        showNoQte: false ,
        showPopoverBtnCopy : false,
        showNumSession : false,
        actifDevisBtn: false,
        actifAjoutNumSession : true,
        SaltEncode: "test",
        resultQteDispo: false,
        listeCount : 0 ,
        prePanierAfterDevis: []
      }
    },
    watch: {
      StoreShowPrePanierListeChange: function () {
        this.checkQte()
        },
    },
    mounted(){
      this.SaltEncode = process.env.VUE_APP_SALT_ENCODE 
      this.envWebName = this.$store.state.storeGlobal.StoreEnvWeb
    },
    computed: {
      // a computed getter
        storeSessionId(){
          return this.$store.state.storeUser.sessionId
        },
        /** Env */
        StoreEnvWeb() {
                      return this.$store.state.storeGlobal.StoreEnvWeb
                  },
        /** PrePanier du store */
        StoreShowPrePanierListe() {
                      return this.$store.state.storePrePanier.StoreShowPrePanierListe
                  },
        StoreShowPrePanierListeChange() {
                      return this.$store.state.storePrePanier.StoreShowPrePanierListe.length
                  },
  
        /** PrePanier du store */
        storeEmailClient() {
                      return this.$store.state.storeEmailClient.emails
                  },
        /** Verification s'il y a une fiche technique encours de creation */
        ficheTechniqueLoading() {
        //console.log("ficheTechniqueLoading")
        //console.log(this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus.some(status => status !== false))
                      // check if there is any fiche technique not currently equal to false
                      return this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus
                  },
    },
    created() {
     
        },
    methods:{
      clickShowPopoverErreur(){
        this.showPopoverErreur = true
      },
      logoBtn(){
        if( this.$store.state.storePrePanier.StoreShowPrePanierListe.toString() == this.$store.state.storePrePanier.StorePrePanierAddDevis.toString())
        {return 'success'}else{return 'cart-o'}
      },
      onSelectQteDispo(id_perso){
          this.showPopoverQteCable = []
          this.showPopoverQteCable[id_perso] = true
      },
        /** PrePanier du store */
      checkQte(){
        var arrayString = JSON.stringify(this.$store.state.storePrePanier.StoreShowPrePanierListe)
        var array = JSON.parse(arrayString)
      
            var unique = null;
            unique = [];
  
            for(var i = 0; i < array.length; i++ ){
  
              /**
               * Longueur disponible
               */
              if(array[i].refGerree == true){
                array[i].longueur = 0;
              }
                if( this.globalFunction.existKeyInArray( array[i].reference_cable, unique ) ){
                unique[array[i].reference_cable]["longueurUse"].push({ ligne : array[i].id_perso , longueur : parseInt(array[i].longueur)})
              }
              else{
                unique[array[i].reference_cable] = []
                unique[array[i].reference_cable]["qte"] = array[i].qte_stock_cable
                unique[array[i].reference_cable]["longueurUse"] = []
                unique[array[i].reference_cable]["longueurUse"].push({ ligne : array[i].id_perso , longueur : parseInt(array[i].longueur)})
                
              }
  
            
        }
        //this.resultQteDispo = []
        this.resultQteDispo = this.referenceQuantiteDispo( unique )
   
        //this.showNoQte = true
      },
      referenceQuantiteDispo(datas){
        var result = []
        const entries = Object.entries(datas);
  
        /**
         * Boucle sur reference
         */
        for(let data of entries){
  
          var ref = data[0] ;
  
        var longueursDemande = (data[1].longueurUse)
        
        const sortDesc = (a, b) => a - b;
        //console.log(data[1].qte)
        //console.log(Object.values(data[1].qte))
        var LongueursDispo  = Object.values(data[1].qte)
        //console.log(JSON.parse(JSON.stringify(LongueursDispo)));
        //console.log(LongueursDispo)
        //
        /**
         * Boucle sur stock de cable disponible
         */
        
         
  
         for (const longueurDemande of longueursDemande ) {
        
         
  
            //i longueur demande et supp à la dispo
  
            for (const [key, LongueurDispo] of Object.entries(LongueursDispo.sort(sortDesc))) {
    
  
          //console.log("check longueur dispo " + LongueurDispo);
          //Boucle sur les longeurs demandées
          var maxDisponible = Math.max(...Object.values(LongueursDispo))
  
          //Si longeur demandé n'existe pas dans le tableau de longueur disponible
          if( longueurDemande.longueur > maxDisponible ){  
        
  
            result.push({ 'id_ligne' : longueurDemande.ligne  ,'cable' : ref , 'longueur' : longueurDemande.longueur , 'erreur' : 'stock-bas' })
  
          break;
          }  
  
          else if( longueurDemande.longueur < LongueurDispo  ){
           
             
    
           
              LongueursDispo[key] = LongueursDispo[key] - longueurDemande.longueur
      
  
              var maxDisponibleLong = Math.max(...Object.values(LongueursDispo))
              if(maxDisponibleLong < 350 ) {
                result.push({ 'id_ligne' : longueurDemande.ligne  ,'cable' : ref , 'longueur' : longueurDemande.longueur , 'erreur' : 'stock-moyen' })
              }
              else{
                result.push({ 'id_ligne' : longueurDemande.ligne  ,'cable' : ref , 'longueur' : longueurDemande.longueur , 'erreur' : 'stock-haut' })
              }
              break;
            }       
       
        }     
          }
          
  
  
         
         
   
         // console.log(qteCables)
     
        }
  
          return result
      },
      str_limit(value, size) {
      if (!value) return '';
      value = value.toString();
  
      if (value.length <= size) {
        return value;
      }
      return value.substr(0, size) + '...';
    },
      strLcFirst(a){return (a+'').charAt(0).toLowerCase()+a.substr(1);},
  
      /**
       * Ajout au panier Rexel
       */
      addCart(){
  
        this.prePanier = this.$store.state.storePrePanier.StoreShowPrePanierListe;
  
  
        /********************** Ref non gerrée ***********************/
  /*
  var jsontest = {
    "id": "Configurateur fibre optique",
    "quantity": 1,
    "products": [
      {
        "quantity": "1",
        "reference": "PRET0476",
        "productId":"PRET0476",
        "edi": "CONFIGURATIONID==ggm-lfwd19o9uqy1m91#REAL_REF==PRK 8TBM3LCLC700#PALLIER_REF==GGMPRET0476"
      }
    ],
  }*/
  this.jsonData = {
  /*  "totalProductCount": this.prePanier.length,*/
    "ConfiguratorName":"Fibre préconnectorisée",
    
    "products" : [{
        id: "Configurateur fibre optique",
        title: "Configurateur fibre optique",
        product: []
    }]
  };
  
  
  //var count = 0;
  for (let i of this.prePanier) {
  
  
    /**
     * Ajout au panier refrence prk
     */
      if( i.etat == true && i.refGerree == false ){
  
        const datasPrk =  {
        
          productCode : (this.$CryptoJS.AES.decrypt(i.pa_ref_palier, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).replace(/ /g,'').substring(3),
          quantity : 1,
          codeRexel: (this.$CryptoJS.AES.decrypt(i.pa_ref_palier, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).replace(/ /g,''),
          manufactureId : (this.$CryptoJS.AES.decrypt(i.pa_ref_palier, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).substring(4),
          brandId : "GGM",
          customId : 'C==' + this.storeSessionId + 
          '#R==' + 
          this.$CryptoJS.AES.decrypt(i.pa_prk, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8).replace(/ /g,'') 
          }
    
  
           this.jsonData.products[0].product.push(datasPrk) ;
      // "products" : []
    
      }
      if( i.etat == true && i.refGerree == true ){
  
        /*
  const datasGgm = {
   // ean: this.$CryptoJS.AES.decrypt(i.ean, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8),
    productCode: i.ref_prk.replace(/ /g,'').substring(3) ,
    manufactureId : i.ref_prk.replace(/ /g,'').substring(3),
    brandId : "GGM",
    codeRexel: i.ref_prk.replace(/ /g,''),
    quantity: 1,
  };
  */
  
  const datasGgm = {
          productCode : i.ref_prk.replace(/ /g,'').substring(3),
          quantity : 1,
          codeRexel: i.ref_prk.replace(/ /g,''),
          manufactureId : i.ref_prk.replace(/ /g,'').substring(3),
          brandId : "GGM",
          customId : 'C==' + this.storeSessionId + 
          '#R==' + 
          i.ref_prk.replace(/ /g,'')
       
  };
  
  this.jsonData.products[0].product.push(datasGgm) ;
  
  } 
  /*
        const datas = {
           quantity : "1",
          productCode : (this.$CryptoJS.AES.decrypt(i.pa_ref_palier, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).replace(/ /g,''),
          manufactureId : (this.$CryptoJS.AES.decrypt(i.pa_ref_palier, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)).substring(4),
          brandId : "GGM"
          };
      */
      //this.jsonData.products[0].product[count] = datas;
      //this.jsonData.products.push(datasInit) ;
      //count++;
  
      this.globalFunction.updateLogConfiguration(this, i.pk, {"ajout_panier_webshop": true}); 
      
    }
  
  
  
   //Qte de produit dan sle prepanier à l'état TRUE
   this.jsonData['totalProductCount'] =  this.jsonData.products.length;
  
  this.msg = JSON.stringify(this.jsonData);
  
  
  
  
  
  /********************** Ref gerrée ***********************/
  
  
  this.jsonData2 = {
  /*  "totalProductCount": this.prePanier.length,*/
    "ConfiguratorName":"Fibre préconnectorisée",
    
    "products" : []
  };
  
  
  
  //var count2 = 0;
  //console.log(count2);
  for (let i of this.prePanier) {
  
    /**
     * Ajoute au panier reference gerree
     */
      if( i.etat == true && i.refGerree == true ){
  
        const datasInit2 = {
        id: "Configurateur fibre optique",
        title: "Configurateur fibre optique",
        product: [{
          ean: this.$CryptoJS.AES.decrypt(i.ean, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8),
          productCode: i.ref_prk.replace(/ /g,'') ,
          quantity: 1,
      }],
      };
  
      this.jsonData2.products.push(datasInit2);
  
      //count2++;
  
      //console.log(i.ref_prk); // affiche 3, 5, 7 dans la console
      //console.log(this.prePanier)
      this.globalFunction.updateLogConfiguration(this, i.pk, {"ajout_panier_webshop": true}); 
      
    }
  
  }
  
   //Qte de produit dan sle prepanier à l'état TRUE
   this.jsonData2['totalProductCount'] =  this.jsonData2.products.length;
  
  
   this.msg = JSON.stringify(this.jsonData);
  
   //console.log(JSON.stringify(jsontest));
    //parent.postMessage(JSON.stringify(jsontest),"*");
  
    parent.postMessage(this.msg,"*");
  
  /*
  if(count > 0){
    console.log(this.msg);
    //console.log(JSON.stringify(jsontest));
    //parent.postMessage(JSON.stringify(jsontest),"*");
    parent.postMessage(this.msg,"*");
  }
  if(count2 > 0){
    console.log(this.msg2);
    parent.postMessage(this.msg2,"*");
  }
  */
  
      },
  
  
      CreateFicheTech(item){
        this.showDoc = item.id_perso;
        fetch(this.$store.state.storeGlobal.StoreApi + '/fiche-technique', {
          method: "POST",
          headers: {
                'Content-Type': 'application/json'
              },
          body: JSON.stringify(item),
          //mode: 'no-cors',
        }
        ) 
        .then((response) => { 
          return response; 
        })
        .then(() => {
       
       
          var ref_prk = item.ref_prk.replace(/ /g,'_') + '_' + item.id_perso ;
        
          window.open(this.$store.state.storeGlobal.StoreApi + '/pdf/' + ref_prk + '.pdf', '_blank');
  
          this.showDoc = false;
            
            /*
          var a = document.createElement("a");
          a.href = window.URL.createObjectURL("http://localhost:8080/pdf/PRK_8PKM3LCLC120.pdf");
          a.download = "FILENAME.pdf";
          a.click();
          */
        });
  
      },
      demanderMonDevis() {
  
        this.prePanierAfterDevis = JSON.stringify(this.$store.state.storePrePanier.StoreShowPrePanierListe)
        this.prePanierAfterDevis = JSON.parse(this.prePanierAfterDevis)
        this.$store.state.storePrePanier.StorePrePanierAddDevis = this.prePanierAfterDevis
        
      this.devisGenEncours = true;
     
     
  
        const panier = this.$store.state.storePrePanier.StoreShowPrePanierListe;
        const clients = this.$store.state.storeEmailClient.emails;
      
        fetch(this.$store.state.storeGlobal.StoreApi + '/createDevisPanier', {
          method: "POST",
          //headers: {
          //      'Content-Type': 'application/json'
          //    },
          body: JSON.stringify({
            user: this.$store.state.storeUser.user, 
            panier: panier, 
            clients: clients ,
            envweb: this.$store.state.storeGlobal.StoreEnvWeb
          
          }),
          //mode: 'no-cors',
        }
        ) 
        .then((response) => { 
        
          return response.json(); 
        })
        .then((data) => {
          //Env customerCare
          if( this.$store.state.storeGlobal.StoreEnvWeb == "CustomerCare GIGAMEDIA"){
            showNotify({
                message: this.$t('Devis mail') ,
                type: 'success',
                duration: 3000,
                position: 'bottom',
              });
  
          }
           //Env customerCare
           if( this.$store.state.storeGlobal.StoreEnvWeb == "Site Gigamedia"){
            showNotify({
                message: this.$t('Devis mail gigamedia') ,
                type: 'success',
                duration: 3000,
                position: 'bottom',
              });
  
          }
    
          try {
              JSON.parse(data);
          } catch (e) {
              //todo show error
              this.devisGenEncours = false;
          
              return false;
          }
         
          const parsedData = JSON.parse(data)
    
          const pk_devis = parsedData.pk_devis
          const version = parsedData.version
          for (const [item_id_perso, item] of Object.entries(parsedData.configs)) {
            // get configuration from this.$store.state.storePrePanier.StoreShowPrePanierListe using item_id_perso
            const configuration = this.$store.state.storePrePanier.StoreShowPrePanierListe.find(item => item.id_perso == item_id_perso)
       
            if(typeof configuration.fk_devis === 'undefined' && typeof configuration.pk !== 'undefined') {
              // new devis for configuration
              const values = {
                ligne_devis: item.ligne_devis,
                delai: item.delai,
              }
           
              this.globalFunction.updateLogConfiguration(this, configuration.pk, {"fk_devis": pk_devis, "devis_version": version, ...values }); 
            } else {
              // new devis for configuration with old devis
              configuration.fk_devis = pk_devis
              configuration.devis_version = version
              configuration.ligne_devis = item.ligne_devis
              configuration.delai = item.delai
              this.globalFunction.logConfiguration(this, configuration)
            }
            this.globalFunction.MajLignePrePanierNoPa(this, item_id_perso , 'fk_devis' , pk_devis );
            this.globalFunction.MajLignePrePanierNoPa(this, item_id_perso , 'devis_version' , version );
            this.globalFunction.MajLignePrePanierNoPa(this, item_id_perso , 'ligne_devis' , item.ligne_devis );
            this.globalFunction.MajLignePrePanierNoPa(this, item_id_perso , 'delai' , item.delai );
          }
      
          this.devisGenEncours = false;
        });
      
      },
  
  
      test(id_perso){
        this.globalFunction.MajLignePrePanier(this.$store, id_perso);
      },
       /*** Calcule prix palier cable + co a et co b */
       decodeData(data){
          
        var decodephp =  this.$CryptoJS.AES.decrypt(data, process.env.VUE_APP_SALT_ENCODE).toString(this.$CryptoJS.enc.Utf8)
         return decodephp
      },
      getArrayCount(){
        var countListe = this.$store.state.storePrePanier.StoreShowPrePanierListe;
        this.countArrayPrePanier = countListe.length;
      },
      //Suppression ligne prePanier
        DeleteLignePrePanier(id_perso){
          //Recalcule du stock
          
          
              this.globalFunction.DeleteLignePrePanier(this.$store, id_perso);
              showNotify({
                message: this.$t('Élément supprimé'),
                type: 'success',
                duration: 4000,
                position: 'bottom',
              });
              this.checkQte()
            },
            
           
        }
  }
  
  </script>
  
  <style>
  
  </style>
  
  